export default __webpack_public_path__ + "media/images/lp/howto-sp-1743c2acdcbcf42a94c85084fdc9fd0d.jpg";